import { Token } from '@/pages/race-wizard';
import { getTokenColor } from '@/utils/tokens';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

const TokensMetricsChart = ({
  pieData,
  tokens,
  allocations,
}: {
  tokens: Token[];
  allocations: Record<string, number>;
  pieData: { name: string; value: number; color: string }[];
}) => {
  return (
    <div className="flex max-w-96 flex-col gap-4 lg:flex-row lg:gap-2">
      <div className="h-64 w-full min-w-64 -rotate-90">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={pieData}
              innerRadius="60%"
              outerRadius="100%"
              paddingAngle={4}
              dataKey="value"
              cornerRadius={4}
              stroke="transparent"
            >
              {pieData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div className="flex h-full shrink-0 flex-row flex-wrap items-center justify-center gap-4 lg:flex-col lg:flex-nowrap lg:items-start">
        {tokens?.map(token => {
          const tokenAllocation = allocations[token.symbol] || 0;
          return (
            <div key={token.symbol} className="flex items-center gap-1 text-sm">
              <div className="size-3.5 rounded-full" style={{ backgroundColor: getTokenColor(token.symbol) }} />
              <span className="text-sm opacity-80">
                {token.symbol}: {tokenAllocation}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TokensMetricsChart;
